export default __webpack_public_path__ + "static/media/nestlé.4a75902b.png";